// Formats a price using the tour's currency code.
const SYMBOLS = {
  USD: "$", EUR: "€", GBP: "£", CAD: "C$", AUD: "A$",
  XCD: "EC$", BBD: "Bds$", JMD: "J$", TTD: "TT$", BSD: "B$",
};

export function currencySymbol(code) {
  const c = (code || "USD").toUpperCase();
  return SYMBOLS[c] || `${c} `;
}

export function formatPrice(amount, currency, opts = {}) {
  const sym = currencySymbol(currency);
  const n = Number(amount || 0).toLocaleString(undefined, {
    maximumFractionDigits: opts.decimals ?? 0,
  });
  return `${sym}${n}`;
}
